/* Progressive enhancement for the temporary care-category fallback. */
(function () {
  'use strict';
  function initialise(root) {
    root.querySelectorAll('[data-dl-care-link]').forEach(function (link) {
      if (link.dataset.dlBound) return;
      var details = document.getElementById(link.getAttribute('aria-controls'));
      if (!details) return;
      link.dataset.dlBound = 'true';
      link.addEventListener('click', function () {
        details.open = true;
        link.setAttribute('aria-expanded', 'true');
        details.querySelector('summary').focus({ preventScroll: true });
      });
      details.addEventListener('toggle', function () {
        link.setAttribute('aria-expanded', String(details.open));
      });
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
}());
